import { Form } from "antd";
import BaseModalForm from "components/BaseModalForm";
import message from "components/CustomMessage";
import { MODAL_SIZE_MEDIUM } from "constants/Layout";
import { PermissionSetMap } from "constants/RBACConstants";
import _ from "lodash";
import React, { forwardRef } from "react";
import ToolsIntegrationsAPI from "restAPI/ToolsIntegrationAPI";
import { hasPermission } from "utils/authService";
import {
  FieldTypes,
  nameRegexValidator,
  urlRegexValidator,
} from "utils/formUtils";
import ModalUtil from "utils/modalUtil";
import { duplicateNameValidator } from "utils/validatorUtil";

import JiraMappingForm from "../jira/JiraMappingForm";

type ATSConfigLoginFormProps = {
  name: string;
  loginConfigList: any[];
  handleMapping: (response: any) => void;
  config: any;
  onUpdateConfigComponent: (shouldUpdate?: boolean) => void;
  afterClose: () => void;
  displayName: string;
};

function ATSConfigLoginForm(
  { name, loginConfigList, handleMapping, ...props }: ATSConfigLoginFormProps,
  ref: any,
) {
  const isEdit = !_.isUndefined(props.config);
  const [form] = Form.useForm();

  const onOk = async () => {
    await form.validateFields();
    try {
      const payload = form.getFieldsValue();
      const response = await ToolsIntegrationsAPI[
        !isEdit
          ? "postTicketSystemToolLoginDetails"
          : "updateTicketSystemToolLoginDetails"
      ]("ARMORCODE_TICKETING_SYSTEM", payload, props.config?.id).promise;

      message.success(`${name} Login Configuration created`);
      if (!isEdit) {
        if (_.isFunction(handleMapping)) {
          handleMapping(response);
        } else {
          ModalUtil.show({
            content: (
              <JiraMappingForm
                onUpdateConfigComponent={props.onUpdateConfigComponent}
                name={name}
                loginConfigId={response.id}
              />
            ),
          });
        }
      }
      props?.onUpdateConfigComponent(true);
    } catch (err: any) {
      console.log(err);
      if (!_.isEmpty(err.response.data.errors)) {
        const { field, defaultMessage } = err.response.data.errors[0];
        form.setFields([
          {
            name: field,
            errors: [defaultMessage],
          },
        ]);
      }
      return Promise.reject(err.response?.data?.message);
    }
  };

  const modalProps = {
    title: (
      <>
        {isEdit ? "Edit" : "Add"} {props.displayName} Login Credentials{" "}
      </>
    ),
    width: MODAL_SIZE_MEDIUM,
    disabled: !hasPermission(
      isEdit ? PermissionSetMap.EDIT_TOOL_CONFIG : PermissionSetMap.WRITE_TOOLS,
    ),
  };

  const fields = [
    {
      name: "name",
      label: "Name",
      colSpan: 12,
      props: {
        autoFocus: true,
      },
      required: true,
      rules: [
        duplicateNameValidator({ list: loginConfigList }),
        nameRegexValidator,
      ],
    },
    {
      name: "userName",
      label: "Email",
      colSpan: 12,
      required: true,
    },
    {
      name: "apiToken",
      label: "Password",
      type: FieldTypes.PASSWORD,
      colSpan: 12,
      required: true,
    },
    {
      name: "url",
      label: "URL",
      colSpan: 12,
      rules: [urlRegexValidator],
      // required: true,
    },
  ];

  const ModalFormComponent = BaseModalForm;

  return (
    <ModalFormComponent
      modalProps={modalProps}
      ref={ref}
      afterClose={props.afterClose}
      initialValues={props.config}
      form={form}
      fields={fields}
      onOk={onOk}
      title={modalProps.title}
    />
  );
}

export default forwardRef(ATSConfigLoginForm);
